<template>
  <b-row>
    <b-col cols="12" v-if="can('read/laporan-uang-harian')">
      <b-card title="Laporan Uang Harian">
        <b-row class="pb-2">
          <b-col class="mb-1">
            <b-button
              v-if="can('filter/laporan-uang-harian')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="ml-0 mr-2"
              @click="show=true"
            >
              Filter
            </b-button>
            <b-button
              v-if="can('print/laporan-uang-harian')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class=""
              @click="exportData()"
              :disabled="totalRows == 0"
            >
              Export Data
            </b-button>
          </b-col>

          <b-col md="4" xs="12">
            <b-form @submit.prevent="handleSearch">
              <b-input-group size="8">
                <b-form-input
                  id="filterInput"
                  v-model="search"
                  type="search"
                  :placeholder="'Cari disini...'"
                />
                <b-input-group-append>
                  <b-button :disabled="!search" @click="search = ''">
                    Hapus
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form>
          </b-col>
        </b-row>

        <b-table
          striped
          hover
          responsive
          show-empty
          class="position-relative"
          primary-key="email"
          :per-page="perPage"
          :current-page="currentPage"
          :items="getItems"
          :fields="regionalUser == '99' ? fields : fieldsRegional"
          :busy="busy"
          ref="tableFe"
        >
          <template #table-busy>
            <div class="text-center my-3">
              <!-- <b-spinner small type="grow" label="Loading..."></b-spinner> -->
              <div>Loading data, please wait...</div>
            </div>
          </template>
          <template #empty>
            <div class="text-center my-2">Data tidak tersedia</div>
          </template>
          <template #emptyfiltered>
            <div class="text-center my-2">Data tidak tersedia</div>
          </template>

          <template #cell(no)="data">
            <span v-if="!data.item.isTotal">
              {{ (currentPage - 1) * perPage + (data.index + 1) }}
            </span>
          </template>

          <template #cell(position)="data">
            <span v-if="!data.item.isTotal">
              {{ data.item.position }}
            </span>
            <span v-else class="font-weight-bold d-block">Total Page ke {{ currentPage }}</span>
          </template>

          <template #cell(name)="data">
            <span v-if="!data.item.isTotal">
            {{ data.item.nippos }} / {{ data.item.name }}
            </span>
          </template>

          <template #cell(departure_date)="data">
            {{ data.item.departure_date | moment('DD-MM-YYYY') }}
          </template>

          <template #cell(return_date)="data">
            {{ data.item.return_date | moment('DD-MM-YYYY') }}
          </template>

          <template #cell(total_days)="data">
            <span v-if="!data.item.isTotal">
            {{ data.item.total_days + ' hari' }}
            </span>
          </template>

          <template #cell(bsu)="data">
            <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
              {{ data.item.bsu | currency }}
              <!-- {{ (data.item.total_days * data.item.bsu) | currency }} -->
            </span>
            <span v-else class="font-weight-bold text-right d-block">{{ totalUangHArian | currency }}</span>
          </template>

          <template #cell(pph21)="data">
            <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
              {{ data.item.bsu_pajak | currency }}
            </span>
            <span v-else class="font-weight-bold text-right d-block">{{ totalPPH21 | currency }}</span>
          </template>

          <template #cell(total)="data">
            <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
              {{ data.item.total_all | currency }}
            </span>
            <span v-else class="font-weight-bold text-right d-block">{{ totalAll | currency }}</span>
          </template>

          <!-- A virtual column -->
          <template #cell(Aksi)="data">
            <div v-if="!data.item.isTotal" style="min-width: 270px">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="info"
                v-b-popover.hover.bottom="'Detail'"
                size="sm"
                class="btn-icon float-sm-left mr-1"
              >
                <feather-icon icon="EyeIcon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                v-b-popover.hover.bottom="'Approve'"
                size="sm"
                class="btn-icon float-sm-left mr-1"
              >
                <feather-icon icon="CheckIcon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="warning"
                v-b-popover.hover.bottom="'Ubah'"
                size="sm"
                class="btn-icon float-sm-left mr-1"
              >
                <feather-icon icon="EditIcon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                v-b-popover.hover.bottom="'Hapus'"
                size="sm"
                class="btn-icon float-sm-left mr-1"
                @click="confirmText(data.item.id)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </template>
        </b-table>

        <span v-if="totalRows == 1" style="margin: 1rem"></span>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- page length -->
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              @change="changePerPage()"
              size="sm"
              inline
              :options="pageOptions"
            />
          </b-form-group>

          <div>
            Menampilkan {{ from }} hingga {{ to }} dari {{ totalRows }} entri
          </div>

          <!-- pagination -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>

            <!-- Modal -->
            <b-modal
              id="modal-filter"
              v-model="show"
              title="Filter"
              size="md"
              cancel-variant="outline-secondary"
            >
              <div class="hidden-scrollbar">
                <div class="inner">
                  <b-form @submit.prevent="handleSubmit(filter)">
                    <b-row>
                      <b-col md="12">
                        <label>Sumber Anggaran</label>
                        <multiselect
                          placeholder="Sumber Anggaran"
                          v-model="model.type_project"
                          label="text"
                          track-by="value"
                          :options="selectProjectOption"
                        ></multiselect>
                      </b-col>
                      <b-col md="6" class= "mt-1" v-if="regionalUser == '99'">
                        <label>Sub Direktorat</label>
                        <multiselect
                          placeholder="Cari Sub Direktorat"
                          v-model="model.code_subdirektorat"
                          label="namabagian_child"
                          track-by="kodebagian_child"
                          :options="subdirLists"
                          @input="changeSubdir"
                        ></multiselect>
                      </b-col>
                      <b-col md="6" class= "mt-1" v-if="regionalUser != '99'">
                        <label>REGIONAL</label>
                        <multiselect 
                          v-model="model.code_regional"
                          name="idwilayah"
                          label="nmwilayah"
                          track-by="idwilayah" 
                          placeholder="Cari Regional"
                          :options="regional"
                          class="single-select filter-laporan-sppd"
                          :max-height="600"
                          :disabled="true"
                          @input="selectedUPT(model.code_regional.idwilayah, model.code_regional.nopen)">
                          <span slot="noResult">Maaf UPT tidak ditemukan</span>
                        </multiselect>
                      </b-col>
                      <b-col md="6" class= "mt-1" v-if="regionalUser != '99'">
                        <label>KCU</label>
                        <multiselect 
                          v-model="selectKCU"
                          name="nopend"
                          label="namaktr"
                          track-by="nopend" 
                          placeholder="Cari KCU"
                          :options="kcu"
                          :disabled="isKCUDisable"
                          class="single-select filter-laporan-sppd"
                          :max-height="600"
                          @input="onKCUChange">
                          <span slot="noResult">Maaf KCU tidak ditemukan</span>
                        </multiselect>
                      </b-col>
                      <b-col md="6" class= "mt-1" v-if="regionalUser != '99'">
                        <label>KC</label>
                        <multiselect 
                          v-model="selectKC"
                          name="nopend"
                          label="namaktr"
                          track-by="nopend" 
                          placeholder="Cari KC"
                          :options="kc"
                          :disabled="isKCDisable"
                          class="single-select filter-laporan-sppd"
                          :max-height="600"
                          @input="onKCChange">
                          <span slot="noResult">Maaf KC tidak ditemukan</span>
                        </multiselect>
                      </b-col>
                      <b-col md="6" class= "mt-1" v-if="regionalUser != '99'">
                        <label>KCP</label>
                        <multiselect 
                          v-model="selectKCP"
                          name="nopend"
                          label="namaktr"
                          track-by="nopend" 
                          placeholder="Cari KCP"
                          :options="kcp"
                          :disabled="isKCPDisable"
                          class="single-select filter-laporan-sppd"
                          :max-height="600"
                          @input="selectedNIPPOSKCP(selectKCP.nopend)">
                          <span slot="noResult">Maaf KCP tidak ditemukan</span>
                        </multiselect>
                      </b-col>
                      <b-col md="6" class= "mt-1" v-if="role_name != 'Pegawai'">
                        <label>NIPPOS</label>
                        <multiselect 
                          v-model="selectNIPPOS"
                          name="nippos"
                          label="nippos"
                          track-by="nippos" 
                          placeholder="Cari NIPPOS"
                          :options="nippos"
                          class="single-select filter-laporan-sppd"
                          :max-height="600"
                          @input="selectedSPPD(selectNIPPOS.nippos)">
                          <span slot="noResult">Maaf NIPPOS tidak ditemukan</span>
                        </multiselect>
                      </b-col>
                      <b-col md="6" class= "mt-1">
                        <label>No SPPD</label>
                        <v-select v-model="model.sppd_number" :options="sppd" :reduce="(item) => item.sppd_number" label="sppd_number" class="key-filter" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-1 mt-1">
                      <b-col md="6">
                        <label>Tanggal Berangkat</label>
                        <br>
                        <date-picker
                          :firstDayOfWeek="1"
                          v-model="model.departure_date"
                          name="departure_date"
                          :lang="lang"
                          :format="formats"
                          value-type="YYYY-MM-DD"
                          ></date-picker>
                      </b-col>
                      <b-col md="6">
                        <label>Tanggal Kembali</label>
                        <br>
                        <date-picker
                          :firstDayOfWeek="1"
                          v-model="model.return_date"
                          name="return_date"
                          :lang="lang"
                          :format="formats"
                          value-type="YYYY-MM-DD"
                          ></date-picker>
                      </b-col>
                    </b-row>
                  </b-form>
                </div>
              </div>
              <template #modal-footer>
                <div class="w-100">
                  <b-button
                    variant="outline-secondary"
                    size="md"
                    class="float-right"
                    @click="reset()"
                  >
                    Reset
                  </b-button>
                  <b-button
                    variant="primary"
                    size="md"
                    class="float-right btn btn-primary mr-1"
                    @click="filter()"
                  >
                    Submit
                  </b-button>
                </div>
              </template>
            </b-modal>
          </div>
        </b-card-body>

        <b-card-body class="d-flex flex-wrap">
          <table>
            <tr>
              <th style="width: 180px;">Total BSU Harian</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAllUangHarian | currency }}</th>
            </tr>
            <tr>
              <th style="width: 180px;">Total PPH21</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAllPPH21 | currency }}</th>
            </tr>
            <tr>
              <th style="width: 180px;">Total Semua</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAlls | currency }}</th>
            </tr>
          </table>
          <!-- <div>
            <h5>Total BSU Harian: {{ totalAllUangHarian | currency }}</h5>
            <h5>Total PPH21: {{ totalAllPPH21 | currency }}</h5>
            <h5>Total Sumua: {{ totalAlls | currency }}</h5>
          </div> -->
        </b-card-body>

      </b-card>
    </b-col>
    <b-col v-else>
      <b-card>
        <div class="col-12 p-2 p-sm-3 mb-4 mt-3">
          <div class="w-100 text-center">
            <h2 class="mb-1">Tidak Memiliki Akses</h2>
            <p class="mb-2">Anda tidak memiliki akses pada halaman ini</p>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<style>
.width160px {
  width: 160px !important;
  background-color: 'red !important';
}
</style>

<script>
import {
  BForm,
  BRow,
  BCol,
  BTable,
  BCard,
  BButton,
  BButtonGroup,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BCardBody,
  BFormGroup,
  BFormSelect,
  BPagination,
  VBPopover,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import TableFe from '@/views/table/bs-table/TableFE'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import Multiselect from 'vue-multiselect';
import { getUserData, getUserRole } from '@/auth/utils';

export default {
  name: 'SppdList',
  components: {
    BForm,
    BRow,
    BCol,
    BTable,
    BCard,
    TableFe,
    BButton,
    BButtonGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BCardBody,
    BFormGroup,
    BFormSelect,
    vSelect,
    BPagination,
    VBPopover,
    BFormCheckbox,
    Multiselect,
  },
  directives: {
    Ripple,
    'b-popover': VBPopover,
  },
  data() {
    return {
      config: {
        api: '/report-moneys',
        subdir: '/misc/sub-direktorat',
      },
      show: false,
      search: '',
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      from: 1,
      to: 10,
      sortBy: 'id',
      pageOptions: [1, 10, 25, 50, 100],
      fields: [
        'no',
        { key: "project_type", label: "Sumber Anggaran" },
        { key: "name_subdirektorat", label: "Sub Direktorat" },
        { key: 'sppd_number', label: 'No SPPD' },
        { key: 'name', label: 'NIPPOS / Nama' },
        { key: 'position', label: 'Jabatan' },
        { key: 'destination_office', label: 'Kantor/Kota Tujuan' },
        { key: 'departure_date', label: 'Tanggal Berangkat' },
        { key: "return_date", label: "Tanggal Kembali" },
        { key: 'total_days', label: 'Total Hari' },
        { key: 'bsu', label: 'BSU Harian' },
        { key: 'pph21', label: 'PPH 21' },
        { key: 'total', label: 'Total' },
      ],
      fieldsRegional: [
        'no',
        { key: "project_type", label: "Sumber Anggaran" },
        { key: "name_regional", label: "Regional" },
        { key: "name_kcu", label: "KCU" },
        { key: "name_kc", label: "KC" },
        { key: "name_kcp", label: "KCP" },
        { key: 'sppd_number', label: 'No SPPD' },
        { key: 'name', label: 'NIPPOS / Nama' },
        { key: 'position', label: 'Jabatan' },
        { key: 'destination_office', label: 'Kantor/Kota Tujuan' },
        { key: 'departure_date', label: 'Tanggal Berangkat' },
        { key: "return_date", label: "Tanggal Kembali" },
        { key: 'total_days', label: 'Total Hari' },
        { key: 'bsu', label: 'BSU Harian' },
        { key: 'pph21', label: 'PPH 21' },
        { key: 'total', label: 'Total' },
      ],
      items: [
        {
          id: 1,
          selected: 'male',
          selected1: 'designer',
          prevHeight: 0,
        },
      ],
      totalUangHarian: 0,
      totalPPH21: 0,
      totalAll: 0,
      totalAllUangHarian: 0,
      totalAllPPH21: 0,
      totalAlls: 0,
      userData: getUserData(),
      report: [],
      key_filter: [
        { key: 'nippos', label: 'NIPPOS' },
        { key: 'sppd_number', label: 'No SPPD' },
        { key: 'name', label: 'Nama' },
        { key: 'departure_date', label: 'Tanggal Berangkat' },
        { key: 'return_date', label: 'Tanggal Kembali' },
      ],
      model: {
        nippos: '',
        sppd_number: '',
        name: '',
        departure_date: '',
        return_date: '',
        type_project: null,
        code_subdirektorat: null,
        name_subdirektorat: '',
        code_regional: null,
        name_regional: '',
      },
      nextTodoId: 2,
      formats: 'DD-MM-YYYY',
      lang: {
        days: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'Mei',
          'Jun',
          'Jul',
          'Agu',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        pickers: [
          'next 7 days',
          'next 30 days',
          'previous 7 days',
          'previous 30 days',
        ],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range',
        },
      },
      isTriger: false,
      busy: false,
      subdirLists: [],
      regional: [],
      kcu: [],
      kc: [],
      kcp: [],
      selectKCU: null,
      selectKC: null,
      selectKCP: null,
      // selectKCU: {
      //   nopend: '',
      //   namaktr: "SEMUA KCU",
      // },
      // selectKC: {
      //   nopend: '',
      //   namaktr: "SEMUA KC",
      // },
      // selectKCP: {
      //   nopend: '',
      //   namaktr: "SEMUA KCP",
      // },
      isSubdirDisabled: false,
      isRegionalDisabled: false,
      isKCDisable: false,
      isKCUDisable: false,
      isKCPDisable: false,
      nippos: [],
      selectNIPPOS: '',
      sppd: [],
      selectProjectOption: [
        { text: 'Cari Sumber Anggaran', value: ''},
        { text: 'Project', value: 'project'},
        { text: 'Non Project', value: 'non project'},
      ],
      regionalUser: getUserData().regional,
      // role_name: JSON.parse(localStorage.getItem('userData')).role_name,
      role_name: getUserRole(),
      scope: getUserData().scope,
    }
  },
  watch: {
    search: function () {
      this.isTriger = true;
      this.$refs.tableFe.refresh();
      // this.getTotalAnggaran();
    },
  },
  mounted() {
    let _ = this
    console.log("user", _.userData);
    

    if (_.$route.params) {
      if (_.$route.params.event) {
        _.makeToast(
          _.$route.params.event,
          _.$route.params.title,
          _.$route.params.text,
        )
      }
    }
    _.getReports()
    _.getSubdirList()
    _.getRegional()
    _.getNIPPOS()

    if(_.role_name == 'Pegawai') {
      _.selectNIPPOS.nippos = _.userData.nippos;
      _.selectedSPPD(_.userData.nippos)
    }
  },
  methods: {
    disabledDate(date) {
      return new Date() < date
    },
    getItems(ctx, callback) {
      const _ = this
      _.busy = true;

      let endpoint = `${_.config.api}?isTriger=${_.isTriger}&per_page=${_.perPage}&page=${_.currentPage}`
      if (_.search) {
        endpoint += `&key=${_.search}`
      }
      // console.log("type project", _.model.type_project.value);
      
      if (_.model.type_project) {
        console.log("Type Project", _.model.type_project.value);
        
        endpoint += `&project_type=${_.model.type_project.value}`;
      }
      if (_.model.code_regional != null) {
        console.log("Regional", _.model.code_regional);
        
        endpoint += `&regional=${_.model.code_regional.idwilayah}|${_.model.code_regional.nmwilayah}`
      }
      if (_.model.code_subdirektorat != null) { 
        console.log("Sub Direktorat", _.model.code_subdirektorat);
        endpoint += `&subdir=${_.model.code_subdirektorat.kodebagian_child}|${_.model.code_subdirektorat.namabagian_child}`
      }
      if (_.selectNIPPOS.nippos) {
        endpoint += `&nippos=${_.selectNIPPOS.nippos}|${_.selectNIPPOS.nama}`
      }
      if (_.model.sppd_number) {
        endpoint += `&sppd_number=${_.model.sppd_number}`
      }
      if (_.model.name) {
        endpoint += `&name=${_.model.name}`
      }
      if (_.model.departure_date) {
        endpoint += `&departure_date=${_.model.departure_date}`
      }
      if (_.model.return_date) {
        endpoint += `&return_date=${_.model.return_date}`
      }
      
      if (_.selectKCU && _.selectKCU.nopend != "") {
        // endpoint += `&nopend=${_.selectKCU.nopend}`
        endpoint += `&nopend_kcu=${_.selectKCU.nopend}|${_.selectKCU.namaktr}`
      }
      // if (_.selectKCU == []) {
      //   endpoint += `&nopend=[]`
      // }
      if (_.selectKC && _.selectKC.nopend != "") {
        endpoint += `&nopend_kc=${_.selectKC.nopend}|${_.selectKC.namaktr}`
      }
      if(_.selectKCP && _.selectKCP.nopend != "") {
        endpoint += `&nopend_kcp=${_.selectKCP.nopend}|${_.selectKCP.namaktr}`
      }

      axios
        .get(encodeURI(endpoint))
        .then(resp => {
          const consume = resp.data.data
          _.data = resp.data.data
          _.perPage = consume.per_page
          _.currentPage = consume.current_page
          _.totalRows = consume.total ?? 0
          _.from = consume.from ?? 0
          _.to = consume.to ?? 0

          let totalUangHArian = 0
          let totalPPH21 = 0
          let totalAll = 0
          if (consume.data && Array.isArray(consume.data)) {
            consume.data.forEach(item => {
              totalUangHArian += Number(item.bsu) || 0
              totalPPH21 += Number(item.bsu_pajak) || 0
              totalAll += Number(item.total_all) || 0
            })
          }
          console.log("Total Uang Harian", totalUangHArian);
          console.log("Total PPH21", totalPPH21); 
          console.log("Total All", totalAll);

          _.totalUangHArian = totalUangHArian
          _.totalPPH21 = totalPPH21
          _.totalAll = totalAll
          
          // callback(consume.data || [])
          callback([
            ...(consume.data || []),
            { isTotal: true }
          ])
        })
        .catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        })
        .finally(() => {
          _.busy = false;
        });
        this.getTotalAnggaran();
    },
    getTotalAnggaran() {
      const _ = this
      _.busy = true;

      let endpoint = `${_.config.api}/summary?isTriger=${_.isTriger}&per_page=${_.perPage}&page=${_.currentPage}`
      if (_.search) {
        endpoint += `&key=${_.search}`
      }
      // console.log("type project", _.model.type_project.value);
      
      if (_.model.type_project) {
        console.log("Type Project", _.model.type_project.value);
        
        endpoint += `&project_type=${_.model.type_project.value}`;
      }
      if (_.model.code_regional != null) {
        console.log("Regional", _.model.code_regional);
        
        endpoint += `&regional=${_.model.code_regional.idwilayah}|${_.model.code_regional.nmwilayah}`
      }
      if (_.model.code_subdirektorat != null) { 
        console.log("Sub Direktorat", _.model.code_subdirektorat);
        endpoint += `&subdir=${_.model.code_subdirektorat.kodebagian_child}|${_.model.code_subdirektorat.namabagian_child}`
      }
      if (_.selectNIPPOS.nippos) {
        endpoint += `&nippos=${_.selectNIPPOS.nippos}|${_.selectNIPPOS.nama}`
      }
      if (_.model.sppd_number) {
        endpoint += `&sppd_number=${_.model.sppd_number}`
      }
      if (_.model.name) {
        endpoint += `&name=${_.model.name}`
      }
      if (_.model.departure_date) {
        endpoint += `&departure_date=${_.model.departure_date}`
      }
      if (_.model.return_date) {
        endpoint += `&return_date=${_.model.return_date}`
      }
      
      if (_.selectKCU && _.selectKCU.nopend != "") {
        // endpoint += `&nopend=${_.selectKCU.nopend}`
        endpoint += `&nopend_kcu=${_.selectKCU.nopend}|${_.selectKCU.namaktr}`
      }
      // if (_.selectKCU == []) {
      //   endpoint += `&nopend=[]`
      // }
      if (_.selectKC && _.selectKC.nopend != "") {
        endpoint += `&nopend_kc=${_.selectKC.nopend}|${_.selectKC.namaktr}`
      }
      if(_.selectKCP && _.selectKCP.nopend != "") {
        endpoint += `&nopend_kcp=${_.selectKCP.nopend}|${_.selectKCP.namaktr}`
      }

      axios
        .get(encodeURI(endpoint))
        .then(resp => {
          const consume = resp.data.data
          
          _.totalAllUangHarian = consume.total_daily_money || 0
          _.totalAllPPH21 = consume.total_pph21 || 0
          _.totalAlls = consume.total_all_pph21 || 0
          
        })
        .catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        })
        .finally(() => {
          _.busy = false;
        });
    },
    handleSearch() {
      this.isTriger = true;
      this.$refs.tableFe.refresh();
      // this.getTotalAnggaran();
    },
    changePerPage() {
      const _ = this
      _.isTriger = true;
      _.$refs.tableFe.refresh()
    },
    changeCurrentPage(currentPage) {
      let _ = this
      _.currentPage = currentPage
    },
    makeToast(variant = null, title = 'Title here...', text = 'Text here...') {
      this.$bvToast.toast(text, {
        title,
        variant,
        solid: true,
      })
    },
    exportData() {
      let _ = this
      if(_.totalRows > 0){
        let today = new Date()
        let dateNow = today
          .toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
          })
          .replace(/[^\d,.-]/g, '-')
        let timeNow =
          today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds()
        // let endpoint = `${_.config.api + '/export'}?isTriger=${_.isTriger}&key=${_.search}`
        
        // if (_.search) {
        //   endpoint += `&key=${_.search}`
        // }
        // // console.log("type project", _.model.type_project.value);
        
        // if (_.model.type_project) {
        //   console.log("Type Project", _.model.type_project.value);
          
        //   endpoint += `&project_type=${_.model.type_project.value}`;
        // }
        // if (_.model.code_regional != null) {
        //   endpoint += `&regional=${_.model.code_regional.idwilayah}|${_.model.code_regional.nmwilayah}`
        // }
        // if (_.model.code_subdirektorat != null) { 
        //   console.log("Sub Direktorat", _.model.code_subdirektorat);
        //   endpoint += `&subdir=${_.model.code_subdirektorat.kodebagian_child}|${_.model.code_subdirektorat.namabagian_child}`
        // }
        // if (_.model.nippos) {
        //   endpoint += `&nippos=${_.model.nippos.nippos}|${_.model.nippos.name}`
        // }
        // if (_.model.sppd_number) {
        //   endpoint += `&sppd_number=${_.model.sppd_number}`
        // }
        // if (_.model.name) {
        //   endpoint += `&name=${_.model.name}`
        // }
        // if (_.model.departure_date) {
        //   endpoint += `&departure_date=${_.model.departure_date}`
        // }
        // if (_.model.return_date) {
        //   endpoint += `&return_date=${_.model.return_date}`
        // }
        
        // if (_.selectKCU && _.selectKCU.nopend) {
        //   // endpoint += `&nopend=${_.selectKCU.nopend}`
        //   endpoint += `&nopend_kcu=${_.selectKCU.nopend}|${_.selectKCU.namaktr}`
        // }
        // // if (_.selectKCU == []) {
        // //   endpoint += `&nopend=[]`
        // // }
        // if (_.selectKC && _.selectKC.nopend) {
        //   endpoint += `&nopend_kc=${_.selectKC.nopend}|${_.selectKC.namaktr}`
        // }
        // if(_.selectKCP && _.selectKCP.nopend) {
        //   endpoint += `&nopend_kcp=${_.selectKCP.nopend}|${_.selectKCP.namaktr}`
        // }
        const params = new URLSearchParams();

        params.append('isTriger', _.isTriger);
        params.append('key', _.search || '');

        if (_.model.type_project) {
          params.append('project_type', _.model.type_project.value);
        }

        if (_.model.code_regional) {
          params.append('regional', `${_.model.code_regional.idwilayah}|${_.model.code_regional.nmwilayah}`);
        }

        if (_.model.code_subdirektorat) {
          params.append('subdir', `${_.model.code_subdirektorat.kodebagian_child}|${_.model.code_subdirektorat.namabagian_child}`);
        }

        if (_.selectNIPPOS.nippos) {
          params.append('nippos', `${_.selectNIPPOS.nippos}|${_.selectNIPPOS.nama}`);
        }

        if (_.model.sppd_number) {
          params.append('sppd_number', _.model.sppd_number);
        }

        if (_.model.name) {
          params.append('name', _.model.name);
        }

        // if (_.selectedMitraTransportation.id) {
        //   params.append('mitra_transportation', `${_.selectedMitraTransportation.id}|${_.selectedMitraTransportation.agen_name}`);
        // }
        // if (_.selectedAccomodation.id) {
        //   params.append('mitra_accomodation', `${_.selectedAccomodation.id}|${_.selectedAccomodation.agen_name}`);
        // }

        if (_.model.departure_date) {
          params.append('departure_date', _.model.departure_date);
        }

        if (_.model.return_date) {
          params.append('return_date', _.model.return_date);
        }

        if (_.selectKCU?.nopend) {
          params.append('nopend_kcu', `${_.selectKCU.nopend}|${_.selectKCU.namaktr}`);
        }

        if (_.selectKC?.nopend) {
          params.append('nopend_kc', `${_.selectKC.nopend}|${_.selectKC.namaktr}`);
        }

        if (_.selectKCP?.nopend) {
          params.append('nopend_kcp', `${_.selectKCP.nopend}|${_.selectKCP.namaktr}`);
        }

        const endpoint = `${_.config.api}/export?${params.toString()}`;

        axios({
          url: endpoint,
          method: 'GET',
          responseType: 'blob',
        }).then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            'laporan-uang-harian' + dateNow + '-' + timeNow + '.xls',
          )
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    getReports() {
      let _ = this
      let uri = '/misc/report'
      axios
        .get(uri + '?company=' + _.userData.nopend)
        .then(resp => {
          _.report = resp.data.data
        })
        .catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
    },
    getNIPPOS(){
      let _ = this
      let uri = "/misc/employees"
      axios.get(uri+ '?company=' + _.userData.nopend).then(resp => {
          _.nippos = resp.data.data
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    selectedSPPD(id){
      let _ = this
      let uri = "/misc/sppds"
      axios.get(uri+ '?nippos=' + id).then(resp => {
          _.sppd = resp.data.data
          _.model.sppd_number=''
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    changeSubdir(){
      this.model.code_regional = null;
      this.selectKCU = '',
      this.selectKC = '',
      this.selectKCP = '',
      this.selectNIPPOS = '',
      this.isSubdirDisabled = false;
      this.isRegionalDisabled = true;
      this.isKCDisable = true;
      this.isKCUDisable = true;
      this.isKCPDisable = true;

      // console.log(this.subdirData.kodebagian_child);
      // this.model.code_subdirektorat = this.model.code_subdirektorat.kodebagian_child;
      // this.model.name_subdirektorat = this.model.code_subdirektorat.namabagian_child;
      
      if (this.model.code_subdirektorat.kodebagian_child == '') {
        this.isRegionalDisabled = false;
        this.isKCDisable = false;
        this.isKCUDisable = false;
        this.isKCPDisable = false;
      }
    },
    getSubdirList() {
      axios.get(this.config.subdir).then(response => {
        this.subdirLists = response.data.data
        this.subdirLists.unshift({
                kodebagian_child: "",
                namabagian_child: "Cari Sub Direktorat",
            })
      })
      .catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    getRegional(){
        let _ = this
        let uri = "/misc/regionals"
        axios.get(uri).then(resp => {
          _.regional = resp.data.data.data
          _.regional.unshift({
            idwilayah: "",
            nmwilayah: "Pilih Regional",
          })
          _.model.code_regional = _.regional.filter((item) => {
            return item.idwilayah == _.regionalUser
          })[0] || null;

          _.isRegionalDisabled = true;
          console.log("regionalUser", _.isRegionalDisabled);
          if(_.model.code_regional.idwilayah != "99") {
            _.selectedUPT(_.model.code_regional.idwilayah, _.model.code_regional.nopen);
          }
          
          // _.regional.unshift({
          //       idwilayah: ["99", "03", "02", "01"],
          //       nmwilayah: "SEMUA REGIONAL",
          //   })
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
    },
    selectedUPT(id, kcu_id){
        let _ = this
        _.model.code_subdirektorat = null
        _.isSubdirDisabled = true;
        _.isRegionalDisabled = false;
        // _.isKCDisable = false;
        // _.isKCUDisable = false;
        // _.isKCPDisable = false;
        if(id == undefined || id == null || id == '') {
          console.log("wew");
        } else {
          console.log("wew else");
        }
        
        console.log("idWilayah "+id);
        
        // if (_.regional.idwilayah == '') {
        if (id == '') {
          _.isSubdirDisabled = false;
        } else if(id == '99') {
          _.isKCDisable = true;
          _.isKCUDisable = true; 
          _.isKCPDisable = true;
        } else {
          _.isKCDisable = false;
          _.isKCUDisable = false;
          _.isKCPDisable = false;
        } 
        
        if(id != '99'){
          _.selectedKCU(kcu_id);
        }
    },
    selectedKCU(id){
      if(id != "" && id != "0"){
        let _ = this;
        let uri = "/misc/companies/kcu/"+id
        axios.get(uri).then(resp => {
          var data = resp.data.data.data || [];
          // if(data.length === 0){
          //   data.where((item) => {
          //     return item.idwilayah !== "99"
          //   });
          //   console.log(data);
            
          //   // _.kantorList = resp.data.data
          // }
            _.kcu = data
            _.kcu.unshift({
                nopend: '0',
                namaktr: "SEMUA KCU",
            })
            _.selectKCU= ''
            // _.selectKCU= {
            //   nopend: '',
            //   namaktr: "SEMUA KCU",
            // }
            // _.selectKCU.nopend = ''
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    selectedKC(id){
      let _ = this;
      
      if(id != "" && id != "0"){
        // Jika dipilih KCU spesifik, ambil KC dari KCU tersebut
        let uri = "/misc/companies/kc/"+id;
        axios.get(uri).then(resp => {
            _.kc = resp.data.data.data || []
            _.kc.unshift({
                nopend: '0',
                namaktr: "SEMUA KC",
            })
            _.selectKC= ''
            // _.selectKC= {
            //   nopend: '',
            //   namaktr: "SEMUA KC",
            // }
            // _.selectKC.nopend = ''
            // _.selectedNIPPOS(id);
        }).catch(error => {
          console.error(error)
          _.kc = [];

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      } else if(id == "0" && _.model.code_regional && _.model.code_regional.idwilayah && _.model.code_regional.idwilayah != "" && _.model.code_regional.idwilayah != "99") {
        // Jika dipilih SEMUA KCU, ambil semua KC dari regional yang dipilih
        let uri = "/misc/companies/level"
        axios.get(uri+ '?region=' + _.model.code_regional.idwilayah + '&relation=KC').then(resp => {
            _.kc = resp.data.data.data || []
            _.kc.unshift({
                nopend: '0',
                namaktr: "SEMUA KC",
            })
            _.selectKC= ''
        }).catch(error => {
          console.error(error)
          _.kc = [];

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    selectedKCP(id){
      let _ = this;
      
      if(id != "" && id != "0"){
        // Jika dipilih KC spesifik, ambil KCP dari KC tersebut
        let uri = "/misc/companies/kcp/" + id;
        axios.get(uri).then(resp => {
            _.kcp = resp.data.data.data ?? []
            _.kcp.unshift({
                nopend: '0',
                namaktr: "SEMUA KCP",
            })
            _.selectKCP= ''
            // _.selectKCP= {
            //   nopend: '',
            //   namaktr: "SEMUA KCP",
            // }
            // _.selectKCP.nopend = ''
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      } else if(id == "0" && _.model.code_regional && _.model.code_regional.idwilayah && _.model.code_regional.idwilayah != "" && _.model.code_regional.idwilayah != "99") {
        // Jika dipilih SEMUA KC, ambil semua KCP dari regional yang dipilih
        let uri = "/misc/companies/level"
        axios.get(uri+ '?region=' + _.model.code_regional.idwilayah + '&relation=KCP').then(resp => {
            _.kcp = resp.data.data.data ?? []
            _.kcp.unshift({
                nopend: '0',
                namaktr: "SEMUA KCP",
            })
            _.selectKCP= ''
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    selectedNIPPOSKCU(id, kcuId){
      if(id != ""){
        let _ = this
        // _.selectKC = ''
        // _.selectKCP = ''
        let uri = "/misc/employees"
        axios.get(uri+ '?company=' + id +"&kcu_id=" + kcuId).then(resp => {
            _.nippos = resp.data.data
            _.selectNIPPOS=''
            // _.model.nippos.nippos=''
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });

        _.selectedKC(id);
        _.selectedKCP(id);
      }
    },
    selectedNIPPOS(id){
      if (id != "") {
        let _ = this
        _.selectKCU = ''
        let uri = "/misc/employees"
        axios.get(uri+ '?company=' + id).then(resp => {
          _.nippos = resp.data.data
            _.selectNIPPOS=''
            // _.selectNIPPOS.nippos=''
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    selectedNIPPOSKCP(id){
      let _ = this
        // _.selectKCU = ''
        let uri = "/misc/employees"
        axios.get(uri+ '?company=' + id).then(resp => {
          _.nippos = resp.data.data
            _.selectNIPPOS=''
            // _.selectNIPPOS.nippos=''
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
    },
    selectedSPPD(id){
      let _ = this
      let uri = "/misc/sppds"
      axios.get(uri+ '?nippos=' + id).then(resp => {
          _.sppd = resp.data.data
          _.model.sppd_number=''
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    getSPPD(){
      let _ = this
      let uri = "/misc/sppds"
      axios.get(uri+ '?nippos=' + _.userData.nippos).then(resp => {
          _.sppd = resp.data.data
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    repeateAgain() {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
    },
    filter() {
      if (this.model.code_regional == null) {
        this.model.code_regional = null
      }
      if (this.model.code_subdirektorat == null) {
        this.model.code_subdirektorat = null
      }
      if (this.selectKCU == null) {
        this.selectKCU = ''
      }
      if (this.selectKC == null) {
        this.selectKC = ''
      }
      if (this.selectNIPPOS == null) {
        this.selectNIPPOS = ''
      }
      // if (this.model.regional == null) {
      //   this.model.regional = ''
      // }
      if (this.model.company == null) {
        this.model.company = ''
      }
      if (this.selectNIPPOS == null) {
        this.selectNIPPOS = ''
      }
      if (this.model.sppd_number == null) {
        this.model.sppd_number = ''
      }
      // if (this.selectedAccomodation == null) {
      //   this.selectedAccomodation = ''
      // }
      // if (this.selectedMitraTransportation == null) {
      //   this.selectedMitraTransportation = ''
      // }
      // if (this.code_subdirektorat == null) {
      //   this.code_subdirektorat = ''
      //   this.name_subdirektorat = ''
      // }
      if (this.model.type_project == null) {
        this.model.type_project = ''
      }
      this.show = false
      
      this.isTriger = true;
      this.$refs.tableFe.refresh();
      // this.getTotalAnggaran();
    },
    reset() {
      this.show = false,
      (this.selectNIPPOS = ''),
      (this.model.sppd_number = ''),
      (this.model.name = ''),
      (this.model.departure_date = ''),
      (this.model.return_date = ''),
      this.selectUPT = '',
      this.selectKCU = '',
      this.selectKC = '',
      this.selectKCP = '',
      this.model.type_project = null,
      this.model.code_subdirektorat = null, 
      // this.model.code_regional = null,
      this.isSubdirDisabled = false,
      this.isRegionalDisabled = false,
      this.isKCDisable = false,
      this.isKCUDisable = false,
      this.isKCPDisable = false,
      this.show = false,
      this.isTriger = false,
      this.selectedProject = null,
      this.$refs.tableFe.refresh();
      this.getNIPPOS();
      // this.getTotalAnggaran();
    },
    onKCUChange() {
      let _ = this;
      if(_.selectKCU && _.selectKCU.nopend) {
        // Reset KC dan KCP ketika KCU berubah
        _.selectKC = '';
        _.selectKCP = '';
        
        if(_.selectKCU.nopend === '0') {
          // Jika pilih SEMUA KCU, load semua KC dari regional
          _.selectedKC('0');
          // Delay KCP loading to avoid race condition
          setTimeout(() => {
            _.selectedKCP('0');
          }, 100);
        } else {
          // Jika pilih KCU spesifik, load KC dari KCU tersebut
          _.selectedKC(_.selectKCU.nopend);
          setTimeout(() => {
            _.selectedKCP(_.selectKCU.nopend);
          }, 100);
        }
        
        _.selectedNIPPOSKCU(_.selectKCU.nopend, _.selectKCU.kcu);
      }
    },
    onKCChange() {
      let _ = this;
      if(_.selectKC && _.selectKC.nopend) {
        // Reset KCP ketika KC berubah
        _.selectKCP = '';
        
        if(_.selectKC.nopend === '0') {
          // Jika pilih SEMUA KC, load semua KCP dari regional
          _.selectedKCP('0');
        } else {
          // Jika pilih KC spesifik, load KCP dari KC tersebut
          _.selectedKCP(_.selectKC.nopend);
        }
      }
    },
  },
}
</script>

<style>
.b-popover {
  font-size: 10px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
